import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { fadeInUp } from '../services/animations/fadeInUp.animation'
import { ReviewService } from "../services/review.service";
import { ReviewQuestions } from '../services/review-questions.service';
import * as moment from 'moment';

@Component({
	selector: 'app-moderate-reviews',
	templateUrl: './moderate-reviews.component.html',
	animations: [fadeInUp]
})
export class ModerateReviewsComponent implements OnInit {
	searchBy: String = 'Course Name'
	pullReviews: any = {
		actioned: false,
		approved: false,
		sort: 'Oldest',
		userType: 'All',
		searchBy: 'Course Name',
		searchText: ''
	}
	reviews: Array<Object>
	pagedReviews: Array<Object>
	pager: any = {}
	openedReview: any = null
	reviewsSearchForm: FormGroup;
	offset: number = 0
	limit: number = 10

	constructor(
		private reviewService: ReviewService,
		private reviewQuestions: ReviewQuestions,
		private fbuilder: FormBuilder
	) { }

	ngOnInit() {
		this.getReviews()
		this.reviewsSearchForm = this.fbuilder.group({
			'searchText': [null]
		})
	}

	getReviews() {
		this.reviewService.pullReviews(this.pullReviews).subscribe(res => {
			if (res) {
				this.reviews = res.json()
				if (this.reviews.length === 0) {
					this.pagedReviews = []
				} else {
					this.findAll(0, this.limit)
				}
			}
		})
	}

	findAll(offset: number, limit: number) {
		let startIndex = offset
		let endIndex = Math.min(startIndex + limit - 1, this.reviews.length - 1)
		this.pagedReviews = this.reviews.slice(startIndex, endIndex + 1)
	}

	changeSearchBy(event) {
		this.searchBy = event.target.value
	}

	performSearch() {
		const searchText = this.reviewsSearchForm.controls.searchText.value
		this.pullReviews.searchText = searchText
		this.pullReviews.searchBy = this.searchBy
		this.getReviews()
	}

	filterOptions(item, event) {
		let val = event.target.value
		if (item === 'actioned' || item === 'approved') {
			this.pullReviews[item] = (val === 'true')
			if (item === 'actioned' && val === 'false') {
				this.pullReviews.approved = false
			} else if (item === 'actioned' && val === 'true') {
				this.pullReviews.approved = null
			}
		} else {
			this.pullReviews[item] = val
		}
	}

	formatDate(val) {
        return 'posted ' + moment(val).format('DD.MM.YY')
    }

	displayScoreStars(value) {
		let starsSvgs = ''
		let toAdd = (5 - value)
		for (let i = 0; i < Math.floor(value); i++) {
			starsSvgs += '<svg class="c-svgicon c-svgicon--star-full" viewBox="0 0 28 27"><use xlink:href="assets/img/inline.svg#star-full"></use></svg>'
		}
		if (value - Math.floor(value) >= .5) {
			starsSvgs += '<svg class="c-svgicon c-svgicon--star-half" viewBox="0 0 28 27"><use xlink:href="assets/img/inline.svg#star-half"></use></svg>'
			toAdd = (5 - value) - .5
		}
		for (let i = 0; i < toAdd; i++) {
			starsSvgs += '<svg class="c-svgicon c-svgicon--star-empty" viewBox="0 0 28 27" *ngIf="star === 0"><use xlink:href="assets/img/inline.svg#star-empty"></use></svg>'
		}
		return starsSvgs
	}

	displayQuestions(userType, qs) {
		let output = ''
		let questions;
		if (userType === 'Student') {
			questions = this.reviewQuestions.students
		} else {
			questions = this.reviewQuestions.employers
		}
		for (let i in qs) {
			if (qs[i]) {
				let question = ''
				if (i === 'notCompletedBecauseOther') {
					question = 'Please specify'
				} else if (i === 'describesYourSituationStillLooking') {
					question = 'Approximately how long have you been looking for work?'
				} else {
					for (let j = 0; j < questions.length; j++) {
						const element = questions[j];
						if (element.slug === i) {
							question = element.question
							break
						}
					}
				}
				if (question) {
					const answer = qs[i]
					output += `<p class="animate-fadeinup"><span class="label">${question}</span><span class="answer">${answer}</span></p>`
				}
			}
		}
		return output
	}

	openReview(target) {
		const elmsLink = document.getElementsByClassName('open-qs')
		const targetElmlink = document.getElementsByClassName('open-qs-' + target)
		const elms = document.getElementsByClassName('review-qs')
		const targetElm = document.getElementsByClassName('review-qs-' + target)
		for (var i = 0; i < elms.length; i++) {
			elmsLink[i].classList.remove('open')
			elms[i].classList.remove('open')
			elms[i]['style'].maxHeight = 0
		}
		if (target !== this.openedReview) {
			targetElmlink[0].classList.add('open')
			targetElm[0].classList.add('open')
			targetElm[0]['style'].maxHeight = targetElm[0]['scrollHeight'] + 'px'
			this.openedReview = target
		} else {
			this.openedReview = null
		}
	}

	approveDisapprove(action, id) {
		let element = document.getElementById(id)
		element.classList.add('processing')
		const data = { action: action, id: id }
		this.reviewService.approveDisapprove(data).subscribe(res => {
			const result = res.json()
			this.reviews = this.reviews.map((elm: any) => {
				if (elm._id === result._id) {
					elm.actioned = result.actioned
					elm.approved = result.approved
				}
				return elm
			})
			// this.setPage(this.pager.currentPage)
			this.reviewService.getUnactioned()
			element.classList.remove('processing')
		}, err => {
			console.log(err);
		})
	}

	onPageChange(offset) {
		this.offset = offset
		this.findAll(this.offset, this.limit)
		let elems = document.getElementsByClassName('c-profile__section_intro') as HTMLCollectionOf<HTMLElement>
        if (elems) {
            let scrollX = elems[0].offsetLeft
            let scrollY = elems[0].offsetTop
            window.scrollTo(scrollX, scrollY)
        }
	}
}



// WEBPACK FOOTER //
// ./src/app/admin/moderate-reviews.component.ts